import { ProcedureGroup } from './procedureGroup';

export class AlphabetResultItem {
  alphabet: string;
  items: Array<ProcedureGroup> = [];
}
